import Emergencies from "./Emergencies";

export default Emergencies;
